import styled from '@emotion/styled';
import { css } from "@emotion/react";

import { designSystem } from '@/styles/theme';


interface TagProps {
  label: string;
  onRemove?: () => void;
  onClick?: () => void;
  cursor?:string;
  active?:boolean;
  color?:string;
};

const Tag = styled.div<{cursor?: string; active?:boolean, color?:string}>`
  display: inline-flex;
  align-items: center;
  padding: clamp(6px, 1.2vw, 8px) clamp(12px, 2.5vw, 16px);
  border: 1px solid ${({ active }) => (active ? designSystem.colors.primary : '#d2d2d2')};
  border-radius: clamp(16px, 3vw, 20px);
  background: ${({ active }) => (active ? designSystem.colors.primary : 'white')};
  color: ${({ active }) => (active ? 'white' : '#333')};
  cursor: ${(props) => props.cursor || 'pointer'};
  font-size: clamp(12px, 2vw, 14px);
  font-weight: 500;
  margin: clamp(2px, 0.5vw, 4px);
  transition: all 0.2s ease;
  white-space: nowrap;
  box-sizing: border-box;
  flex-shrink: 0;

  &:hover {
    border-color: ${designSystem.colors.primary};
    background: ${({ active }) => (active ? designSystem.colors.primaryDark : '#f8f7ff')};
  }

  ${(props) =>
    props.color &&
    css`
      border: 1px solid ${props.color};
    `};
`;

const RemoveButton = styled.button`
  background: none;
  border: none;
  margin-left: 5px;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
`;

const ChipButton = ({ label, onRemove, onClick, cursor, active, color }: TagProps) => (
  <Tag onClick={onClick} cursor={cursor} active={active} color={color}>
    {label}
    {onRemove && <RemoveButton onClick={onRemove}>x</RemoveButton>}
  </Tag>
);

export default ChipButton;
